import type { TranscodingJobStatus } from '@/api/generated/schemas';

export const publishingStatusColors: Record<string, string> = {
  announced: 'blue',
  available: 'green',
  unavailable: 'default',
  postponed: 'orange',
  cancelled: 'red',
  deleted: 'volcano',
};

/** Distribution-period availability, as rolled up on the product row. */
export const availabilityColors: Record<string, string> = {
  available: 'green',
  upcoming: 'blue',
  expired: 'default',
};

/** Facets behind the "Assets" column filter; each applies as `field[eq]`. */
export const ASSET_FILTER_FIELDS = [
  'is_cover_downloaded',
  'is_master_downloaded',
] as const;

export const transcodingStatusColors: Record<TranscodingJobStatus, string> = {
  pending: 'default',
  requested: 'processing',
  succeeded: 'success',
  failed: 'error',
  superseded: 'warning',
};

export const productTypeColors: Record<string, string> = {
  ebook: 'blue',
  audio: 'purple',
  not_supported: 'default',
};
